import React from 'react';
import EstrategiaModernaPage from './components/EstrategiaModernaPage';

function CursoEstrategiaModerna() {
  return <EstrategiaModernaPage />;
}

export default CursoEstrategiaModerna;
